import { render, staticRenderFns } from "./BaseModalSizeSelector.vue?vue&type=template&id=05dfd1ef&"
import script from "./BaseModalSizeSelector.vue?vue&type=script&lang=js&"
export * from "./BaseModalSizeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05dfd1ef')) {
      api.createRecord('05dfd1ef', component.options)
    } else {
      api.reload('05dfd1ef', component.options)
    }
    module.hot.accept("./BaseModalSizeSelector.vue?vue&type=template&id=05dfd1ef&", function () {
      api.rerender('05dfd1ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseModalSizeSelector.vue"
export default component.exports